// ** Icons Import
import { Home, Activity, ShoppingCart, Grid } from 'react-feather'

export default [
  {
    id: 'dashboards',
    title: 'Home Page',
    icon: <Grid />,
    navLink: '/dashboard/analytics'
  //   children: [
  //     {
  //       id: 'analyticsDash',
  //       title: 'Analytics',
  //       icon: <Activity />,
  //       navLink: '/dashboard/analytics'
  //     },
  //     {
  //       id: 'eCommerceDash',
  //       title: 'eCommerce',
  //       icon: <ShoppingCart />,
  //       navLink: '/dashboard/ecommerce'
  //     }
  //   ]
  }
]
